import React, { useEffect, useState } from "react";
// import { Badge, Button, DropdownButton, InputGroup, Spinner } from "react-bootstrap";
import * as apicall from "../../components/Apicall";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./vendorquote.css";
import { Form, InputGroup, Button, Badge, DropdownButton, Dropdown ,Spinner} from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { STATUS_DROPDOWN, getStatusProps } from "../../constants/status";
import StatusBadge from "../../constants/statusBadge";

const disabledStatuses = ["2", "3", "4", "5", "6", "7", "8", "9", "10", "11","13"];

const VendorQuotation = () => {
  const [activeRfqs, setActiveRFQs] = useState([]);
  const [quotesSubmitted, setQuotedSubmitted] = useState([]);
  const [pendingReviews, setPendingReviews] = useState([]);
  const [activeOrders, setActiveOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("user_details"));
  const [activeView, setActiveView] = useState("ACTIVE_RFQ");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Statuses");

  const VIEWS = {
    ACTIVE_RFQ: "ACTIVE_RFQ",
    QUOTES: "QUOTES",
    PENDING_REVIEW: "PENDING_REVIEW",
    ORDERS: "ORDERS",
  };

  const getActiveRFQ = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`getActiveRFQ/${userDetails?.id}`);
      // const activeRFQs = res.data
       const activeRFQs = (res.data || []).filter(
      item => (item.supplier_status) !== 0
    );
    console.log(activeRFQs,"activeRFQs")
       setActiveRFQs(activeRFQs);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

  const getQuotes = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`getSupplierQuoteCount/${userDetails?.id}`);
      setQuotedSubmitted(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

  const getPendReviews = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`getPendingReviews/${userDetails?.id}`);
      setPendingReviews(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };

  const getActiveOrdersBySupplier = async () => {
    setLoading(true);
    try {
      const res = await apicall.get(`getActiveOrders/${userDetails?.id}`);
      setActiveOrders(res.data);
    } catch (e) {
      toast.error(e.message.replace("Error:", ""));
    } finally {
      setLoading(false);
    }
  };
console.log(userDetails,"userDetails")

  useEffect(() => {
    getActiveRFQ();
    getQuotes();
    getPendReviews();
    getActiveOrdersBySupplier();
  }, []);

  const getListData = () => {
    if (activeView === VIEWS.ACTIVE_RFQ) return activeRfqs;
    if (activeView === VIEWS.PENDING_REVIEW) return pendingReviews;
    if (activeView === VIEWS.QUOTES) return quotesSubmitted;
    if (activeView === VIEWS.ORDERS) return activeOrders;
    return [];
  };
// const getFilteredData = () => {
//   let list = getListData();

//   if (searchTerm.trim() !== "") {
//     const term = searchTerm.toLowerCase();
//     list = list.filter(
//       (rfq) =>
//         rfq.title?.toLowerCase().includes(term) ||
//         rfq.display_rfq_id?.toLowerCase().includes(term) ||
//         rfq.company_info?.name?.toLowerCase().includes(term)
//     );
//   }

//  if (statusFilter !== "All Statuses") {
//   list = list.filter((rfq) => {
//     const { label } = getBadgeProps(rfq);
//     return label === statusFilter;
//   });
// }


//   return list;
// };
const getFilteredData = () => {
  let list = [...getListData()]; // clone array (important)

  //  SORT FIRST (latest created / latest id first)
  list.sort((a, b) => {
    // If created exists → use that
    if (a.created && b.created) {
      return new Date(b.created) - new Date(a.created);
    }

    // Fallback → sort by rfq_id DESC
    return Number(b.rfq_id) - Number(a.rfq_id);
  });

  //  Search Filter
  if (searchTerm.trim() !== "") {
    const term = searchTerm.toLowerCase();
    list = list.filter(
      (rfq) =>
        rfq.title?.toLowerCase().includes(term) ||
        rfq.display_rfq_id?.toLowerCase().includes(term) ||
        rfq.company_info?.name?.toLowerCase().includes(term)
    );
  }

  //  Status Filter
  if (statusFilter !== "All Statuses") {
    list = list.filter((rfq) => {
      const { label } = getBadgeProps(rfq);
      return label === statusFilter;
    });
  }

  return list;
};

const getBadgeProps = (rfq) => {
  const statusCode = rfq.supplier_status;
  return getStatusProps(Number(statusCode));
};

const clearAllFilters = () => {
  setStatusFilter("All Statuses");   
  setSearchTerm("");               
};
  return (
    <div className="container-fluid p-4">
      <div className="rfq-header">
    <h4>Quotations</h4>
  </div>
  <div className="filters-container">

  {/* LEFT FILTERS */}
  <div className="filters-left">

    <div className="filter-search">
      <InputGroup className="custom-search">
        <InputGroup.Text>
          <FaSearch />
        </InputGroup.Text>
        <Form.Control
          type="search"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputGroup>
    </div>

  <div className="filter-status">
  <DropdownButton
    id="status-filter"
    variant="outline-secondary"
    title={statusFilter}
  >
    <div style={{ maxHeight: "200px", overflowY: "auto" }}> {/* scrollable */}
      <Dropdown.Item onClick={() => setStatusFilter("All Statuses")}>
        All Statuses
      </Dropdown.Item>

      {STATUS_DROPDOWN.map((status, index) => {
        const dummyRfq = { supplier_status: index + 1 }; // simulate rfq
        const { badgeColor } = getStatusProps(index + 1);

        return (
          <Dropdown.Item key={index} onClick={() => setStatusFilter(status)}>
            {status}
          </Dropdown.Item>
        );
      })}
    </div>
  </DropdownButton>
</div>


    <div className="filter-clear">
      <button className="btn clear-btn" onClick={clearAllFilters}>
        Clear All
      </button>
    </div>

  </div>

  {/* RIGHT ACTIONS */}

</div>
      {/* Overview Section */}
      {/* <h5 className="mb-3">Overview</h5> */}
      {/* <div className="row g-3 mb-5">
        {overviewData.map((item, i) => (
          <div key={i} className="col-md-3 col-sm-6">
            <div
              className="p-3 rounded shadow-sm border-0 cursor-pointer"
              onClick={() => handleTileClick(item.view)}
              style={{
                backgroundColor: item.bg,
                border: activeView === item.view ? "2px solid #dc3545" : "none",
                cursor: "pointer",
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-2">
                <p className="mb-0 fw-semibold">{item.title}</p>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    backgroundColor: item.iconBg,
                    width: "40px",
                    height: "40px",
                    borderRadius: "10px",
                    fontSize: "20px",
                  }}
                >
                  {item.icon}
                </div>
              </div>
              <h4 className="mb-1">{item.value}</h4>
            </div>
          </div>
        ))}
      </div> */}

      {/* RFQs Section */}
      <div className="p-4 bg-white rounded shadow-sm border">
        {/* <h5 className="mb-1">
          {activeView === VIEWS.ACTIVE_RFQ && "Active RFQs"}
          {activeView === VIEWS.QUOTES && "Quotes Submitted"}
          {activeView === VIEWS.PENDING_REVIEW && "Pending Reviews"}
          {activeView === VIEWS.ORDERS && "Orders Won"}
        </h5>
        <p className="text-muted mb-4">
          {activeView === VIEWS.ACTIVE_RFQ && "Request for Quotations requiring your attention"}
          {activeView === VIEWS.QUOTES && "Quotations submitted by you"}
          {activeView === VIEWS.PENDING_REVIEW && "Quotations awaiting buyer response"}
          {activeView === VIEWS.ORDERS && "Orders confirmed and awarded to you"}
        </p> */}

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : getFilteredData().length > 0 ? (
          <div className="d-flex flex-column gap-3">
             <div className="rfq-header">
  <h4 className="text-secondary">
    Total RFQs<br/>
    <small className="text-muted">View Total RFQs</small>
  </h4>
</div>

            {getFilteredData().map((rfq, idx) => {
              const { badgeColor, label } = getBadgeProps(rfq);
              return (
                <div key={idx} className="rfq-row p-3 bg-white border rounded">
                  {/* Left */}
                  <div>
                    <h6 className="mb-1 d-flex align-items-center gap-2">
                      {rfq.title}
                              {activeView === VIEWS.ACTIVE_RFQ && <StatusBadge status={rfq.supplier_status} />}

                    </h6>
                    <small className="text-muted">{rfq.company_info?.name || "—"}</small>
                    {rfq.category && (
                      <div className="mt-1">
                        <span className="badge bg-light text-dark">{rfq.category}</span>
                      </div>
                    )}
                  </div>

                  {/* RFQ ID */}
                  <div>
                    <span className="text-danger fs-6">{rfq.display_rfq_id || rfq.rfq_id}</span>
                  </div>

                  {/* Price */}
                  <div>
                    <span className="text-success fs-6">${rfq.total_price?.toLocaleString() || 0}</span>
                  </div>

                  {/* Deadline */}
                  <div>
                    <small className="text-muted">
                      Deadline: {rfq.responsible_date ? new Date(rfq.responsible_date).toLocaleDateString() : "—"}
                    </small>
                  </div>

                  {/* Buttons */}
                  {activeView === VIEWS.ACTIVE_RFQ && (
                    <div className="rfq-buttons d-flex gap-2">
                      <Button
                        disabled={rfq.supplier_status === "12"}
                        variant="outline-danger"
                        size="sm"
                        onClick={() => navigate(`/vendor_quatation_details/${rfq.rfq_id}`, { state: { rfq } })}
                      >
                        👁️ View Details
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        disabled={disabledStatuses.includes(String(rfq?.quotation_status)) || rfq.supplier_status === 12}
                        onClick={() => navigate(`/vendor_quatation_form/${rfq.rfq_id}`, { state: { rfq } })}
                      >
                        💬 Submit Quote
                      </Button>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-center text-muted py-4">No RFQs available at the moment</p>
        )}
      </div>
    </div>
  );
};

export default VendorQuotation;
